import AssessmentQuiz from './AssessmentQuiz';
import AssessmentResult from './AssessmentResult';
import Form from './Form';
import LandingPage from './LandingPage';
import Router from './Router';

export default null;
export { Router, AssessmentQuiz, AssessmentResult, Form, LandingPage };



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/index.js